import { render, staticRenderFns } from "./AdministrationTools.vue?vue&type=template&id=375503d4"
import script from "./AdministrationTools.vue?vue&type=script&lang=js"
export * from "./AdministrationTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports